import React from "react";

export const SwitchApplication = (props: { size?: number; borderColor: string }) => {
    const size = props.size || 32;

    return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="4" fill="none" />
            <rect
                x="6.75"
                y="7.24219"
                width="7.38889"
                height="7.38889"
                rx="1.25"
                stroke={props.borderColor}
                strokeWidth="1.5"
            />
            <rect
                x="6.75"
                y="18.3535"
                width="7.38889"
                height="7.38889"
                rx="1.25"
                stroke={props.borderColor}
                strokeWidth="1.5"
            />
            <rect
                x="17.8613"
                y="7.24219"
                width="7.38889"
                height="7.38889"
                rx="1.25"
                stroke={props.borderColor}
                strokeWidth="1.5"
            />
            <rect
                x="17.8613"
                y="18.3535"
                width="7.38889"
                height="7.38889"
                rx="1.25"
                stroke={props.borderColor}
                strokeWidth="1.5"
            />
        </svg>
    );
};
